import { Component } from '@angular/core';

@Component({
    selector: 'import-client',
    templateUrl: './import-client.component.html'
})
export class ImportClientComponent {

}



// WEBPACK FOOTER //
// ./src/app/admin/importclient/import-client.component.ts